import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function BillingCancel() {
    return (
        <div className="bg-background min-h-[70vh] flex items-center" data-testid="billing-cancel-page">
            <div className="mx-auto max-w-xl px-6 text-center">
                <div className="mx-auto w-14 h-14 rounded-full bg-muted border border-border flex items-center justify-center">
                    <XCircle size={28} className="text-muted-foreground" />
                </div>
                <h1 className="mt-4 font-heading font-medium text-3xl sm:text-4xl tracking-tight text-foreground">
                    No charge made.
                </h1>
                <p className="mt-3 text-sm text-muted-foreground">
                    You closed the checkout before finishing. Nothing was billed — you can pick up where you left off any time.
                </p>
                <div className="mt-6 flex flex-col sm:flex-row items-stretch gap-2 justify-center">
                    <Link to="/pricing" className="btn-green text-sm inline-flex items-center justify-center gap-1" data-testid="billing-cancel-retry">
                        Back to pricing <ArrowRight size={13} />
                    </Link>
                    <Link to="/contact" className="btn-outline text-sm inline-flex items-center justify-center gap-1">
                        Ask a question
                    </Link>
                </div>
            </div>
        </div>
    );
}
